import { render, staticRenderFns } from "./batch-form-dz.vue?vue&type=template&id=0d7a4439&"
import script from "./batch-form-dz.vue?vue&type=script&lang=js&"
export * from "./batch-form-dz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports